import React from 'react';
import { motion } from 'framer-motion';
import type { ServiceCardProps } from './types';

const ServiceCardSmall: React.FC<ServiceCardProps> = ({ service, onSelect, buttonText = 'Select' }) => {
  const isSelected = buttonText === 'Selected';
  
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      onClick={() => onSelect(service)}
      className={`rounded-lg overflow-hidden transition-all relative h-64 cursor-pointer ${
        isSelected 
          ? 'ring-4 ring-primary shadow-xl brightness-105' 
          : 'hover:shadow-lg border-2 border-transparent hover:border-gray-300'
      }`}
    >
      {/* Full card background image */}
      <img 
        src={service.image} 
        alt={service.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay only at bottom for content */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
      
      {/* Content overlay */}
      <div className="relative h-full flex flex-col">
        {/* Content area with light black background */}
        <div className="flex-1 flex flex-col justify-end">
          <div className="bg-black/30 p-2 pb-12">
            <h3 className="text-sm font-bold text-white mb-0.5 line-clamp-1">
              {service.name}
            </h3>
            <div className="flex justify-between items-center">
              <span className="text-gray-200 text-xs">
                {service.duration} min
              </span>
              <span className="text-white font-semibold text-xs">
                {service.price}
              </span>
            </div>
          </div>
        </div>
        
        {/* Button fixed at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <button
            onClick={() => onSelect(service)}
            className={`w-full py-2 text-xs text-white hover:bg-primary/90 transition-colors font-semibold ${
              buttonText === 'Selected' 
                ? 'bg-green-600 hover:bg-green-700' 
                : 'bg-primary'
            }`}
          >
            {buttonText === 'Selected' && (
              <span className="material-symbols-outlined text-xs inline-block mr-1">check_circle</span>
            )}
            {buttonText}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCardSmall;
